import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const PriceContext = React.createContext([{}, () => {}]);

const PriceProvider = ({ children }) => {
  const [priceData, setPriceData] = useState({
    deliveryFee: 0,
    minOrder: 0,
    freeDeliveryLimit: 0,
    productTotal: 0,
    total: 0
  });

  useEffect(() => {
    // 2020-12-15 pjung ERINT-943 Ha limit nem 0 vagy NULL...
    // console.log('előtte :', priceData.productTotal, priceData.freeDeliveryLimit, priceData.deliveryFee);
    if (!priceData.freeDeliveryLimit || priceData.productTotal < priceData.freeDeliveryLimit) {
      setPriceData({
        ...priceData,
        total: priceData.productTotal + priceData.deliveryFee
      });
    } else {
      setPriceData({
        ...priceData,
        total: priceData.productTotal
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priceData.productTotal, priceData.deliveryFee, priceData.freeDeliveryLimit]);

  return <PriceContext.Provider value={[priceData, setPriceData]}>{children}</PriceContext.Provider>;
};

PriceProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { PriceContext, PriceProvider };
